import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCartsById, getValueOfAttribut } from 'helpers';
import { platformConstants } from 'constants/Platform.constants';
import ProductTextBloc from './ProductTextBloc';

const { HAS_PLATFORM_EXPORT_KEY } = platformConstants;

class ProductWeightVolume extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weight: this.getWeight(props),
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const nextWeight = this.getWeight(nextProps);
    const { weight } = this.state;

    // Always update if weight changed
    if (weight !== nextWeight) {
      return true;
    }

    // Also update if Redux cart changed (to catch quantity changes)
    // Compare cart_items arrays to detect changes
    const { current, currentPreorder } = this.props;
    const { current: nextCurrent, currentPreorder: nextCurrentPreorder } = nextProps;

    const currentCartItems = current && current.cart_items ? current.cart_items.length : 0;
    const nextCartItems = nextCurrent && nextCurrent.cart_items ? nextCurrent.cart_items.length : 0;

    if (
      current !== nextCurrent ||
      currentPreorder !== nextCurrentPreorder ||
      currentCartItems !== nextCartItems
    ) {
      return true;
    }

    return false;
  }

  componentDidUpdate() {
    const { weight } = this.state;
    const nextWeight = this.getWeight(this.props);
    if (weight !== nextWeight) {
      this.updateState(nextWeight);
    }
  }

  getEffectiveCart(props) {
    const { product, current, currentPreorder, filter } = props;

    if (filter) {
      const { cart: cartId } = filter;
      if (cartId) {
        const carts = getCartsById(cartId);
        if (carts && carts.length) {
          return carts[0];
        }
      }
    }

    return product.is_preorder ? currentPreorder : current;
  }

  getCartItem(props) {
    const { product } = props;
    // For cart items, product.id should match cartItem.item_id
    // (after parseItems spreads item.item into item)
    const productId = product.id || product.item_id;

    if (!productId) {
      return null;
    }

    const effectiveCart = this.getEffectiveCart(props);
    const { cart_items: cartItems } = effectiveCart || {};

    if (!cartItems || !Array.isArray(cartItems)) {
      return null;
    }

    return cartItems.find(({ item_id: itemId }) => String(itemId) === String(productId));
  }

  getWeight(props) {
    const cartItem = this.getCartItem(props);

    if (!cartItem || !cartItem.item || !cartItem.item.package) {
      return null;
    }

    const { quantity } = cartItem;
    const weightGrossPackage = cartItem.item.package.weight_gross_package;

    if (!weightGrossPackage || !quantity) {
      return null;
    }

    const totalWeight = parseFloat(weightGrossPackage) * quantity;

    return totalWeight > 0 ? totalWeight : null;
  }

  getVolume(props) {
    const cartItem = this.getCartItem(props);

    if (!cartItem || !cartItem.item || !cartItem.item.package) {
      return null;
    }

    const { quantity } = cartItem;
    const volumePackage = cartItem.item.package.volume_package;

    if (!volumePackage || !quantity) {
      return null;
    }

    const totalVolume = parseFloat(volumePackage) * quantity;

    return totalVolume > 0 ? totalVolume : null;
  }

  updateState(weight) {
    this.setState({ weight });
  }

  render() {
    const { selectedPlatform, product, ...rest } = this.props;

    const textBlocs = [];

    // Flag ON: Display weight/volume
    const { weight } = this.state;
    const volume = this.getVolume(this.props);

    // Display weight in kg
    if (weight !== null && weight > 0) {
      textBlocs.push({
        content: `${Number.parseFloat(weight).toFixed(2)} kg`,
        isBold: true,
      });
    }

    // Display volume in m³ with 3 decimals for consistency with individual item totals
    if (volume !== null && volume > 0) {
      textBlocs.push({
        content: `${Number.parseFloat(volume).toFixed(3)} m³`,
        isSmall: true,
      });
    }

    return (
      <ProductTextBloc
        {...rest}
        textBlocs={textBlocs.length > 0 ? textBlocs : undefined}
        text={textBlocs.length === 0 ? '-' : undefined}
      />
    );
  }
}

ProductWeightVolume.propTypes = {
  className: PropTypes.string,
  product: PropTypes.object,
  current: PropTypes.object,
  currentPreorder: PropTypes.object,
  filter: PropTypes.object,
  shouldShowResponsive: PropTypes.bool,
  selectedPlatform: PropTypes.object,
};

ProductWeightVolume.defaultProps = {
  shouldShowResponsive: false,
};

const mapStateToProps = (state) => {
  const { cart, platform } = state;
  const { current, currentPreorder } = cart;
  const { platforms, selectedId } = platform;
  const selectedPlatform = platforms.find((p) => Number(p.id) === Number(selectedId)) || {};
  return {
    current,
    currentPreorder,
    selectedPlatform,
  };
};

export default connect(mapStateToProps)(ProductWeightVolume);
